import React, { useEffect } from "react";
import LockedPage from "../Locked";
import { useNavigationBar } from "../../context/NavigationContext";
import ContainerNavigation from "../../components/ContainerNavigation";
import { useNavigate } from "react-router-dom";

const Payments = () => {
  const { setNavProps, navProps } = useNavigationBar();
  const navigate = useNavigate();

  useEffect(() => {
    setNavProps({
      backArrow: false,
      title: "Payments",
      subtitle: "Channel",
      buttonTitle: "Onboarding",
      filterOption: false,
      enableLink: true,
      onBack: () => alert("Back Clicked"),
      onFilter: () => {},
      onNext: () => navigate("../onboarding"),
    });
  }, [setNavProps, navigate]);

  const { backArrow, title, subtitle, buttonTitle, enableLink, filterOption, onBack, onFilter, onNext } = navProps;

  return (
    <>
      <ContainerNavigation
        backArrow={backArrow}
        title={title}
        subtitle={subtitle}
        enableLink={enableLink}
        buttonTitle={buttonTitle}
        filterOption={filterOption}
        onBack={onBack}
        onFilter={onFilter}
        onNext={onNext}
      />
      <LockedPage content="view payments" />
    </>
  );
  //
};

export default Payments;
